import {createPage} from 'app/client/ui/createPage';
import {createLoginPage} from 'app/client/ui/loginPages';

createPage(() => createLoginPage());
